import { AccountStatusesEnum } from 'dash-common';
import type { BadgeTypes } from 'dash-ui';

export const USER_STATUSES_BADGE_TYPE: {
  [key in AccountStatusesEnum]: BadgeTypes;
} = {
  [AccountStatusesEnum.ACTIVE]: 'active',
  [AccountStatusesEnum.ADDED]: 'active',
  [AccountStatusesEnum.ARCHIVED]: 'inactive',
  [AccountStatusesEnum.EXPIRED]: 'alert',
  [AccountStatusesEnum.INVITED]: 'neutral',
};
